import React, { useState, useEffect,useMemo } from 'react';
import { PlusCircle, Pencil, Eye, Trash } from 'lucide-react'; 
import { useNavigate } from 'react-router-dom';
import {format} from 'date-fns';
const TemplateList = () => {
  const [userList, setUsersList] = useState([]);
  const navigate = useNavigate();
  const BUId = sessionStorage.getItem('BUId');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userResponse = await fetch(`${process.env.REACT_APP_API_URL}/Mailer/GetTemplateList?BUId=${BUId}`);

        if (!userResponse.ok) {
          throw new Error('Failed to fetch data');
        }

        const data = await userResponse.json();
        setUsersList(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserData();
  }, [BUId]);

  const handleEditTemplate = (user) => {
    console.log('Template data for editing:', user);
    navigate('/CreateTemplate', { state: { userData: user } });
  };

  // Delete template function
  const handleDeleteTemplate = async (user) => {
    const confirmDelete = window.confirm(`Are you sure you want to delete the template "${user.templateName}"?`);
    const currDate = format(new Date(), 'dd/MM/yyyy hh:mm a');
    
    if (confirmDelete) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/Mailer/DeleteTemplate?BUId=${BUId}&TemplateId=${user.templateId}&CreatedOn=${currDate}`, {
          method: 'Patch',
        });
  
        if (!response.ok) {
          throw new Error('Failed to delete template');
        }
  
        const data = await response.json();
        console.log('Template deleted:', data);
  
        // Update the UI after deletion by removing the deleted template from the list
        setUsersList(prevList => {
          // Filter out the deleted template based on templateId
          return prevList.filter(item => item.templateId !== user.templateId);
        });
  
      } catch (error) {
        console.error('Error deleting template:', error);
      }
    } else {
      console.log('Delete action canceled');
    }
  };
  

  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility state
  const [templateData, setTemplateData] = useState(null); // Template data state

  // Function to open modal and set the template data for viewing
  const handleViewTemplate = (user) => {
    console.log('Viewing template data:', user);
    setTemplateData(user); // Set the template data
    setIsModalOpen(true); // Open the modal
  };

  // Function to close modal
  const closeModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const handleAddTemplate = () => {
    navigate('/CreateTemplate');
  };

// Filter and search functionality
  const filteredMails = useMemo(() => {
    const normalizedSearchTerm = searchTerm.toLowerCase();

    return userList.filter(user => {
     const matchesUser = user.templateName && user.templateName.toLowerCase().includes(normalizedSearchTerm);
     const matchesSubject =  user.templateSubject && user.templateSubject.toLowerCase().includes(normalizedSearchTerm);
     const matchesDate = user.createdOn.toLowerCase().includes(normalizedSearchTerm);
      return matchesUser || matchesDate || matchesSubject;
    });
  }, [userList, searchTerm]);

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMails.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(filteredMails.length / itemsPerPage);

  return (
    <div className="p-8">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">TEMPLATES</h1>
        <button
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
          onClick={handleAddTemplate}
        >
          <PlusCircle className="h-4 w-4" />
          Create Template
        </button>
      </div>
  {/* Search Input */}
        <div className="p-4 bg-gray-100 border-b">
          <div className="max-w-md ml-auto relative">

            <input
              type="text"
              placeholder="Search..."
              className="w-full p-3 pl-10 text-gray-700 bg-white rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // Reset to first page when searching
              }}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 absolute left-3 top-3 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
      {/* Table */}
      <div className="w-full overflow-x-auto bg-white rounded-lg shadow">
        <table className="w-full">
          <thead className="bg-gradient-to-r from-blue-500 to-purple-600">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Template Name</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Subject</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Created On</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
                   {currentItems.length > 0 ? (
                currentItems.map((user, index) => (
            //{userList.length > 0 ? (
            //  userList.map((user, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">{user.templateName}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">{user.templateSubject}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">{user.createdOn}</td>
                  <td className="px-6 py-4">
                    <div className="flex gap-2">
                      {/* Edit Button */}
                      <button
                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                        onClick={() => handleEditTemplate(user)}
                      >
                        <Pencil className="h-4 w-4 text-gray-600" />
                      </button>

                      {/* View Button */}
                      <button
                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                        onClick={() => handleViewTemplate(user)}
                      >
                        <Eye className="h-4 w-4 text-gray-600" />
                      </button>
{/* Modal */}
{isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="bg-white p-6 w-3/4 max-w-5xl h-auto rounded-lg shadow-lg">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-semibold">{templateData?.templateName}</h2>
              <button onClick={closeModal} className="text-red-500 text-xl font-bold">X</button>
            </div>
            <div className="mt-4">
              <div 
                className="template-content" 
                style={{ maxHeight: '500px',overflowY:'scroll' }}
                dangerouslySetInnerHTML={{ __html: templateData?.templateContent }} 
              />
            </div>
            <div className="mt-4 text-center">
              <button onClick={closeModal} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      
                      {/* Delete Button */}
                      <button
                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                        onClick={() => handleDeleteTemplate(user)}
                      >
                        <Trash className="h-4 w-4 text-gray-600" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="px-6 py-4 text-sm text-center text-gray-600">No Templates found</td>
              </tr>
            )}
          </tbody>
        </table>
          {/* Pagination */}
        {totalPages > 1 && (
          <div className="bg-gray-100 px-4 py-3 flex items-center justify-center space-x-2">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => paginate(index + 1)}
                className={`px-4 py-2 text-sm font-medium rounded-lg border 
                  ${currentPage === index + 1
                    ? 'bg-blue-500 text-white border-blue-500'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TemplateList;
